import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Swal from "sweetalert2";

function CheckObjectDeletion({ referenceId, reference, showModal, signalCloseModal, action }) {
  const [open, setOpen] = useState(false);

  const handleCancelCreation = () => {
    setOpen(false);
    signalCloseModal(false);
  };

  const handleCreation = (e, referenceId) => {
    setOpen(false);
    signalCloseModal(true, referenceId);
  };

  function createSweetAlert() {
    Swal.fire({
      title: `${
        reference === "platforms"
          ? `${action} Platform?`
          : reference === "filter"
          ? `${action} Filter?`
          : reference === "template"
          ? `${action} Template?`
          : reference === "odd"
          ? `${action} Odd Filter?`
          : reference === "market"
          ? `${action} Market Filter?`
          : `${action} User?`
      }`,
      html: `You are about to ${action} ${reference === "odd" ? " an " : " a "}
                ${
                  reference === "platforms"
                    ? "platform"
                    : reference === "filter"
                    ? "filter"
                    : reference === "template"
                    ? "template"
                    : reference === "odd"
                    ? "odd filter"
                    : reference === "market"
                    ? "market filter"
                    : "user"
                }, with id:
                ${referenceId}. <br />
                Are you sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: action,
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleCreation(result, referenceId);
      } else {
        handleCancelCreation();
      }
    });
  }

  useEffect(() => {
    setOpen(showModal);
    if (showModal) createSweetAlert();
  }, [showModal]);

  return <div></div>;
}

// Setting default values for the props of CreateTemplate
CheckObjectDeletion.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
  action: "Delete",
};

// Typechecking props of the CreateTemplate
CheckObjectDeletion.propTypes = {
  referenceId: PropTypes.number,
  reference: PropTypes.string,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
  action: PropTypes.string,
};

export default CheckObjectDeletion;
